<template>
  <main class="change__main modal" v-if="storeResource">
    <section class="change__card">
      <component
        :is="componentName"
        :unityAndProfile="selectedData"
        @setSelectedData="setSelectedData"
        @changeStep="changeStep"
      >
        <template #loading>
          <Loading />
        </template>
      </component>
    </section>
  </main>
</template>

<script>
import Loading from "./IsLoading.vue";
import List from "./ListUnitiesAndProfiles.vue";
import Confirm from "./ConfirmChange.vue";
import { mapGetters } from "vuex";

export default {
  name: "ChangeUnityProfileComponent",

  data: () => ({
    componentName: "List",
    selectedData: {},
  }),

  computed: {
    ...mapGetters({
      storeResource: "getChangeUnityProfileStatus",
    }),
  },

  components: {
    Loading,
    List,
    Confirm,
  },

  methods: {
    setSelectedData(data) {
      this.selectedData = data;
    },

    changeStep(step) {
      switch (step) {
        case 1:
          return (this.componentName = "List");

        case 2:
          return (this.componentName = "Confirm");

        default:
          return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.change__main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;
  position: fixed;

  .change__card {
    background: #ffffff;
    min-height: 500px;
    max-height: 650px;
    width: 450px;
    border-radius: 20px;
    padding: 20px;
  }
}
</style>
